var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.loaded},[(_vm.isTimedOut)?_c('app-session-timeout-modal'):_vm._e(),(_vm.requiresAuth)?_c('app-header'):_vm._e(),_c('router-view',{ref:"view"}),(_vm.requiresAuth)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }